/* Included only by the new standalone assembly section. */
if (!customElements.get('gdx-assembly-mount')) {
  customElements.define('gdx-assembly-mount', class extends HTMLElement {
    connectedCallback() {
      // Reserve the existing absolute header without changing shared theme code.
      const header = document.querySelector('.custom-header');
      const reserveHeader = () => {
        const css = header && getComputedStyle(header);
        const overlay = css && ['absolute', 'fixed'].includes(css.position);
        const height = overlay ? header.getBoundingClientRect().height + Math.max(0, parseFloat(css.top) || 0) : 0;
        this.style.setProperty('--gdx-assembly-header-space', `${Math.ceil(height)}px`);
      };
      reserveHeader();
      if (header && 'ResizeObserver' in window) {
        this.headerObserver = new ResizeObserver(reserveHeader);
        this.headerObserver.observe(header);
      }
      if (this.started) return;
      this.started = true;
      try {
        const entry = new URL(this.dataset.guideEntry, document.baseURI);
        if (entry.protocol !== 'https:' && !['localhost', '127.0.0.1'].includes(entry.hostname)) throw new Error('Use HTTPS');
        import(entry.href).then(() => this.querySelector('.gdx-assembly-fallback')?.remove()).catch(() => this.showError());
      } catch { this.showError(); }
    }
    disconnectedCallback() { this.headerObserver?.disconnect(); }
    showError() {
      const message = this.querySelector('.gdx-assembly-loading');
      if (message) message.textContent = this.dataset.errorText;
    }
  });
}
